import React, { memo } from 'react'

import { Icon } from '@procsea/design-system'

import { IconProps } from './icons.types'

const FrequentIcon = ({
  'data-e2e': dataE2e = 'is-frequent',
  tooltip = gettext('Frequently ordered product'),
}: IconProps) => (
  <Icon
    data-e2e={dataE2e}
    faStyle="fas"
    name="history"
    size="1x"
    tooltip={tooltip}
    variant="primary"
  />
)

export default memo(FrequentIcon)
